/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_PlacesInputs */

const th_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถานที่`)
};

const en_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Places`)
};

const ja_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会場`)
};

const zh_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地点`)
};

const es_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lugares`)
};

const pt_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locais`)
};

const id_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat`)
};

const fr_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieux`)
};

const tl_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga lugar`)
};

const vi_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa điểm`)
};

const ko_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`장소`)
};

const de_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orte`)
};

const ru_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Места`)
};

const tr_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yerler`)
};

const it_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luoghi`)
};

const pl_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miejsca`)
};

const uk_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Місця`)
};

const hi_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थान`)
};

const ar_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأماكن`)
};

const ms_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat`)
};

const bn_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্থান`)
};

const zh_tw2_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地點`)
};

const zh_hk2_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地點`)
};

const ur_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقامات`)
};

const fa_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مکان‌ها`)
};

const sw_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maeneo`)
};

const nl_event_places = /** @type {(inputs: Event_PlacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plaatsen`)
};

/**
* | output |
* | --- |
* | "Places" |
*
* @param {Event_PlacesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_places = /** @type {((inputs?: Event_PlacesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_PlacesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_places(inputs)
	if (locale === "ja") return ja_event_places(inputs)
	if (locale === "zh") return zh_event_places(inputs)
	if (locale === "es") return es_event_places(inputs)
	if (locale === "pt") return pt_event_places(inputs)
	if (locale === "id") return id_event_places(inputs)
	if (locale === "fr") return fr_event_places(inputs)
	if (locale === "tl") return tl_event_places(inputs)
	if (locale === "vi") return vi_event_places(inputs)
	if (locale === "ko") return ko_event_places(inputs)
	if (locale === "de") return de_event_places(inputs)
	if (locale === "ru") return ru_event_places(inputs)
	if (locale === "tr") return tr_event_places(inputs)
	if (locale === "it") return it_event_places(inputs)
	if (locale === "pl") return pl_event_places(inputs)
	if (locale === "uk") return uk_event_places(inputs)
	if (locale === "hi") return hi_event_places(inputs)
	if (locale === "ar") return ar_event_places(inputs)
	if (locale === "ms") return ms_event_places(inputs)
	if (locale === "bn") return bn_event_places(inputs)
	if (locale === "zh-TW") return zh_tw2_event_places(inputs)
	if (locale === "zh-HK") return zh_hk2_event_places(inputs)
	if (locale === "ur") return ur_event_places(inputs)
	if (locale === "fa") return fa_event_places(inputs)
	if (locale === "sw") return sw_event_places(inputs)
	if (locale === "nl") return nl_event_places(inputs)
	return en_event_places(inputs)
});